import React from "react";
import ReactDOM from "react-dom";

import { MainRoutes } from "./routes";

import "./index.css";

ReactDOM.render(<MainRoutes />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js